import React, { useEffect, useState, useRef, useContext, Fragment } from "react"
import { useIntl, FormattedMessage, Link } from "gatsby-plugin-intl"
import { useQuery, useLazyQuery } from "@apollo/client"
import { useToast } from "@tmu/hooks"

import {
  REGISTER_READER_MUTATION,
  TERMINAL_SIMULATE_CARD_PAYMENT,
  TERMINAL_READER_QUERY,
  TERMINAL_CANCEL_DONATION,
} from "@tmu/apollo/storefront/queries/campaign"
import {
  TERMINAL_OFFER_DETAIL_QUERY,
  TERMINAL_MERCHANT_OFFER_LISTING_QUERY,
} from "@tmu/apollo/storefront/queries/offer"
import { useApolloApiClients } from "@tmu/apollo/client"
import { useAllOfferCategories, useAuth, useTypeConstants } from "@tmu/hooks"
import queryString from "query-string"
import { faArrowLeft } from "@fortawesome/pro-regular-svg-icons/faArrowLeft"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { useLocalStorage, useMediaQuery } from "beautiful-react-hooks"
import {
  Spinner,
  NewCard,
  Button,
  CustomModal,
  TextInput,
  Money,
  LazyImage,
  Loading,
  LogoText,
  MediaSlider,
  Checkbox,
} from "@tmu/components/common"
import FilterBar from "./FilterBar"
import { isBrowser } from "@tmu/utils/auth"
import { useMutation } from "@apollo/client"
import theme from "@tmu/global/theme"

import {
  StyledTerminalWrapper,
  StyledContent,
  StyledHeading,
  StyledListingFilters,
  StyledCampaignList,
  CampaignListAction,
  StyledCampaignsBody,
  NoResults,
  StyledFilterBar,
  StyledHeadingTop,
  StyledDonationSection,
  StyledDonationOptionSection,
  StyledDonationSectionPair,
  StyledCampaignDetail,
  StyledDonationSectionTerminalPairedTop,
  StyledDonationSectionTerminalPaired,
  StyledDonationSectionTerminalPairedOptions,
  StyledDonationOptions,
  StyledDonationSuccessSection,
  StyledSuccessPageImage,
} from "./index.styles"
import { getQueryParams, getValueForLocale } from "@tmu/utils/string"
import { CARDS_PER_PAGE, LIST_TYPES } from "@tmu/apollo/constants"
import { HomePageContext } from "@tmu/context/homePageContext"
import { faXmark } from "@fortawesome/free-solid-svg-icons/faXmark"
import { getAllScreenTypes } from "@tmu/utils/mediaQueries"
import {
  TERMINAL_CREATE_ORDER,
  TERMINAL_START_ORDER_PAYMENT,
  TERMINAL_RETRIEVE_STRIPE_PAYMENT_INTENT,
} from "@tmu/apollo/storefront/mutations/cart"

const simulator = {
  id: "tmr_F0zO7gcUvrx3Hf",
  deviceType: "simulated_wisepos_e",
  label: "simulated-wpe-27c5675b-8f75-42c5-b61c-630f2147e070",
  location: "tml_F0PfZwxdhbgDmh",
  status: "online", //connected or offline
}
const { CLOUDFLARE_IMAGE_URL } = process.env

const Terminal = ({ location }) => {
  const { isLoading } = useAuth()
  const { locale, defaultLocale, formatMessage } = useIntl()
  const { intercomStatus, setIntercomStatus } = useContext(HomePageContext)
  const { isTablet, isDesktop, isWide } = getAllScreenTypes()
  const { success: successToast, error: errorToast } = useToast()

  const ref = useRef()
  const filterBarRef = useRef()
  const loadRef = useRef()
  const [searchText, setSearchText] = useState(null)
  const [connecting, setConnecting] = useState(false)
  const [showEmail, setShowEmail] = useState(true)
  const [email, setEmail] = useState("")
  const [inputReaderId, setInputReaderId] = useState("")
  const [emailError, setEmailError] = useState("")
  const [amountError, setAmountError] = useState("")
  const [readerDetails, setReaderDetails] = useLocalStorage("terminal", null)
  const [loadingAll, setLoadingAll] = useState(false)
  const [threeWords, setThreeWords] = useState("")
  const [readerName, setReaderName] = useState("")
  const [modalStatus, setModalStatus] = useState(false)
  const [isPairingOpen, setPairingOpen] = useState(false)
  const [isTerminalPaired, setTerminalPaired] = useState(true)
  const [isDonationSuccessOpen, setDonationSuccessOpen] = useState(false)
  const [countdown, setCountdown] = useState(null)
  const [selectedDonationAmount, setSelectedDonationAmount] = useState("")
  const [error, setError] = useState("")
  const [otherAmount, setOtherAmount] = useState("")
  const [donationNote, setDonationNote] = useState("")

  const [paymentStatus, setPaymentStatus] = useState()
  const [paymentIntentId, setPaymentIntentId] = useState()
  const [selectedOffer, setSelectedOffer] = useState()
  const [offerList, setOfferList] = useState([])
  const [selectedServiceOption, setSelectedServiceOption] = useState()
  const serviceOptions = selectedOffer?.productVariation?.edges
    ?.map(({ node: variation }) => ({
      id: variation.id,
      donationAmount: variation.price,
      description: getValueForLocale(
        variation,
        "description",
        locale,
        defaultLocale
      ),
      name: getValueForLocale(variation, "name", locale, defaultLocale),
      pacDiscount: variation.pacDiscount,
      allowCustomAmount: variation.allowCustomAmount,
      isSoldOut: variation.isSoldOut,
      isUnlimitedTickets: variation.isUnlimitedTickets,
      maxTickets: variation.maxTickets,
      stockLeft: variation.stockLeft,
    }))
    .sort((a, b) => parseFloat(a.donationAmount) - parseFloat(b.donationAmount))

  const params = getQueryParams()
  const [selectedCategories, setSelectedCategories] = useState([])
  const [selectedCategoryIds, setSelectedCategoryIds] = useState([])
  const { allOfferCategories } = useAllOfferCategories()

  const [getOfferDetail] = useLazyQuery(TERMINAL_OFFER_DETAIL_QUERY, {
    fetchPolicy: "no-cache",
    onCompleted: (data) => setSelectedOffer(data?.offer),
  })

  const [getTerminalDetails] = useLazyQuery(TERMINAL_READER_QUERY, {
    fetchPolicy: "no-cache",
    onCompleted: (data) => {
      setReaderDetails(data?.terminalReader)
      setConnecting(false)
    },
  })

  useEffect(() => {
    if (!readerDetails?.id) return

    const interval = setInterval(async () => {
      try {
        const { data } = await getTerminalDetails({
          variables: { id: readerDetails?.id },
        })
        if (data?.terminalReader) {
          setReaderDetails(data?.terminalReader)
          setConnecting(false)
        }
      } catch (error) {
        console.error("Error fetching terminal details:", error)
        setReaderDetails(null)
        setConnecting(false)
      }
    }, 10000)

    return () => clearInterval(interval)
  }, [getTerminalDetails, readerDetails?.id])

  const [getOrderStatus] = useMutation(
    TERMINAL_RETRIEVE_STRIPE_PAYMENT_INTENT,
    {
      client: storefrontClient,
      fetchPolicy: "no-cache",
      onCompleted: (data) => {
        const status = data?.retrieveStripePaymentIntent?.paymentSuccess

        if (status === "succeeded") {
          setDonationSuccessOpen(true)
          setEmail("")
          setPaymentStatus(null)
        } else {
          setPaymentStatus(status)
        }
      },
      onError: (error) => {
        console.error("Payment status check error:", error)
        if (error.message.includes("Process took too long")) {
          errorToast(
            formatMessage({
              id: "dashboard::stores::errorMessage",
              defaultMessage: "An error occurred",
            })
          )
          setPaymentStatus("ERROR")
        }
      },
    }
  )

  useEffect(() => {
    if (isDonationSuccessOpen) {
      setCountdown(10)
    }
  }, [isDonationSuccessOpen])

  useEffect(() => {
    if (countdown !== null && countdown > 0) {
      const timer = setTimeout(() => setCountdown(countdown - 1), 1000)
      return () => clearTimeout(timer)
    } else if (countdown === 0) {
      handleNewPurchaseClick()
    }
  }, [countdown])

  useEffect(() => {
    if (!paymentIntentId) return

    let interval = null
    let timeout = null

    const checkDonationStatus = async () => {
      if (!paymentIntentId) return
      try {
        const { data } = await getOrderStatus({
          variables: { paymentIntentId },
        })
        if (data?.retrieveStripePaymentIntent?.paymentSuccess === "succeeded") {
          setDonationSuccessOpen(true)
          setPaymentStatus(null)
          setEmail("")
          setLoadingAll(false)
          clearInterval(interval)
          clearTimeout(timeout)
        }
      } catch (error) {
        console.error("Error checking payment status:", error)
        errorToast(
          formatMessage({
            id: "dashboard::stores::errorMessage",
            defaultMessage: "An error occurred",
          })
        )
        setPaymentStatus("ERROR")
        clearInterval(interval)
        clearTimeout(timeout)
        setLoadingAll(false)
      }
    }

    if (paymentStatus === "requires_payment_method") {
      interval = setInterval(checkDonationStatus, 3000)
      timeout = setTimeout(() => {
        handleCancelDonation()
        setPaymentStatus("ERROR")
        clearInterval(interval)
      }, 100000)
    }

    return () => {
      clearInterval(interval)
      clearTimeout(timeout)
    }
  }, [paymentStatus, getOrderStatus, paymentIntentId])

  useEffect(() => {
    if (paymentStatus === "succeeded") {
      setDonationSuccessOpen(true)
      setEmail("")
    }
  }, [paymentStatus])

  useEffect(() => {
    if (params?.offer) {
      getOfferDetail({ variables: { slug: params?.offer } })
    }
  }, [params?.offer])

  const [loadMoreAfter, setLoadMoreAfter] = useState(false)

  const screenSize1 = isBrowser && useMediaQuery(" (max-width:480px)")
  const screenSize2 =
    isBrowser && useMediaQuery("(min-width:481px) and (max-width:767px)")
  const screenSize3 =
    isBrowser && useMediaQuery("(min-width:768px) and (max-width:1023px)")
  const screenSize4 =
    isBrowser && useMediaQuery("(min-width:1024px) and (max-width:1199px)")
  const screenSize5 =
    isBrowser && useMediaQuery("(min-width:1200px) and (max-width:1919px)")
  const screenSize6 = isBrowser && useMediaQuery("(min-width:1920px)")

  const [firstLoad, setFirstLoad] = useState(false)
  const { storefrontClient } = useApolloApiClients()
  const { callTypeConstants, called: callTypeConstantsCalled } =
    useTypeConstants({ callImmediately: false })

  useEffect(() => {
    setIntercomStatus({ hide: true })
  }, [])

  const {
    loading,
    data,
    fetchMore,
    refetch: refetchOfferListing,
  } = useQuery(TERMINAL_MERCHANT_OFFER_LISTING_QUERY, {
    variables: {
      first: CARDS_PER_PAGE,
      orderBy: "-created",
      categories: selectedCategoryIds,
      search: searchText,
      isPublic: true,
      offerOrigin: ["offers"],
      isDefaultOffer: false,
    },
    client: storefrontClient,
    onCompleted: (data) => {
      setFirstLoad(true)
      setOfferList(data?.allOffers?.edges || [])
    },
  })

  const [registerReader] = useMutation(REGISTER_READER_MUTATION, {
    client: storefrontClient,
  })
  const [cancelDonation] = useMutation(TERMINAL_CANCEL_DONATION, {
    client: storefrontClient,
  })

  const [createOrder, { loading: createNewOrderLoading }] = useMutation(
    TERMINAL_CREATE_ORDER,
    {
      client: storefrontClient,
    }
  )

  const [
    startNewOrderPayment,
    { error: startOrderError, data: startOrderData },
  ] = useMutation(TERMINAL_START_ORDER_PAYMENT)

  const [simulatePayment] = useMutation(TERMINAL_SIMULATE_CARD_PAYMENT, {
    client: storefrontClient,
  })

  const handleStartPairing = () => {
    setTerminalPaired(true)
    setPairingOpen(false)
    if (!threeWords || !readerName) {
      setModalStatus(true)
    } else {
      registerReader({
        variables: {
          registrationCode: threeWords,
          label: readerName,
        },
      })
        .then((res) => {
          if (res?.data?.reader?.id) {
            setReaderDetails(res?.data?.registerReader)
            setPairingOpen(false)
            setTerminalPaired(true)
          }
        })
        .finally(() => {
          setThreeWords("")
          setReaderName("")
        })
    }
  }
  useEffect(() => {
    if (isLoading) {
      return
    }

    if (!firstLoad) {
      return
    }

    if (!callTypeConstantsCalled) {
      callTypeConstants()
    }
  }, [isLoading, firstLoad])

  useEffect(() => {
    setSelectedCategoryIds(selectedCategories.map((category) => category.value))
  }, [selectedCategories])

  const changeUrlState = (url) => {
    window?.history?.pushState({}, null, url)
  }

  const validateEmail = (email) => {
    const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
    return re.test(String(email).toLowerCase())
  }

  const handleEmailChange = (e) => {
    const value = e.target.value
    setEmail(value)
    if (!value) {
      setEmailError(
        formatMessage({
          id: "forms::emailRequiredError",
          defaultMessage: "Email is required",
        })
      )
    } else if (!validateEmail(value)) {
      setEmailError(
        formatMessage({
          id: "forms::emailInvalidError",
          defaultMessage: "Enter a valid email",
        })
      )
    } else {
      setEmailError("")
    }
  }

  const handleAmountChange = (e, option) => {
    const value = e.target.value
    const numericValue = parseFloat(value)
    setSelectedServiceOption({
      id: option.id,
      donationAmount: value,
      allowCustomAmount: true,
    })
    if (!value || isNaN(numericValue) || numericValue <= 0) {
      setAmountError(
        formatMessage({
          id: "forms::enterAmount",
          defaultMessage: "Enter a valid amount",
        })
      )
    } else if (numericValue < 5) {
      setAmountError(
        formatMessage(
          {
            id: "forms::donationOption1Error",
            defaultMessage: "Minimum € {value}",
          },
          {
            value: 5,
          }
        )
      )
    } else if (numericValue > 99999.99) {
      setAmountError(
        formatMessage(
          {
            id: "forms::donationMaxAmountError",
            defaultMessage: "The amount must be lower than {value}.",
          },
          {
            value: 99999.99,
          }
        )
      )
    } else {
      setAmountError("")
    }
  }

  const navigateWithParams = (newParams) => {
    const updatedParams = queryString.stringify(
      { ...newParams },
      { arrayFormat: "comma" }
    )
    changeUrlState("?" + updatedParams)
  }

  const handleLoadMore = () => {
    if (loading || !data?.allOffers?.pageInfo?.hasNextPage) return
    const variables = {
      first: CARDS_PER_PAGE,
      orderBy: "-created",
      categories: selectedCategoryIds,
      search: searchText,
      isPublic: true,
      offerOrigin: ["offers"],
      isDefaultOffer: false,
      after: data?.allOffers?.pageInfo?.endCursor,
      offset: null,
    }
    fetchMore({
      variables,
      updateQuery: (prev, { fetchMoreResult }) => {
        if (!fetchMoreResult) return prev

        const newEdges = fetchMoreResult?.allOffers?.edges ?? []
        const pageInfo = fetchMoreResult?.allOffers?.pageInfo

        if (!newEdges.length) return prev

        // Update the local state with new edges
        setOfferList((prev) => [...prev, ...newEdges])

        return {
          allOffers: {
            ...prev.allOffers,
            edges: [...prev.allOffers.edges, ...newEdges],
            pageInfo,
          },
        }
      },
    })
  }

  const handleSimulate = () => {
    if (selectedServiceOption?.donationAmount || selectedDonationAmount) {
      simulatePayment({
        variables: {
          readerId: readerDetails?.id,
        },
      }).then((res) => {
        if (res?.data?.createDonation?.campaign?.id) {
          // setModalStatus(true)
        }
      })
    }
  }

  const handleCancelDonation = async () => {
    if (paymentIntentId) {
      try {
        const res = await cancelDonation({
          variables: {
            paymentIntentId,
            readerId: readerDetails?.id,
          },
        })
        if (res?.data?.cancelPaymentIntent?.paymentIntent?.id) {
          setPaymentStatus("CANCELLED")
          successToast(
            formatMessage({
              id: "dashboard::donations::paymentCancelled",
              defaultMessage: "Payment cancelled successfully",
            })
          )
          setPaymentIntentId(null)
          setPaymentStatus(null)
          setEmail("")
          setLoadingAll(false)
        }
      } catch (error) {
        console.error("Error cancelling payment:", error)
        errorToast(
          formatMessage({
            id: "dashboard::stores::errorMessage",
            defaultMessage: "An error occurred",
          })
        )
      }
    }
  }

  const handleDonate = async () => {
    if (paymentStatus === "requires_payment_method") return
    console.log("starting donation time", new Date())
    setLoadingAll(true)
    try {
      if (selectedServiceOption?.donationAmount || selectedDonationAmount) {
        const input = {
          productVariation: selectedServiceOption?.id,
          currency: "EUR",
          quantity: 1,
          intendedEmail: email || "terminal@trustmeup.com",
          stripePaymentMethodType: "terminal",
        }
        if (selectedServiceOption?.allowCustomAmount) {
          input.customAmount = selectedServiceOption?.donationAmount
        }
        const { data: orderData } = await createOrder({
          variables: {
            input,
          },
        })
        const order = orderData?.createOrder?.order

        console.log(
          "get order response from BE",
          orderData?.createOrder,
          new Date()
        )

        if (order?.id) {
          const { data: paymentData } = await startNewOrderPayment({
            variables: {
              input: {
                id: order?.id,
                intendedEmail: email || "terminal@trustmeup.com",
                stripeReaderId: readerDetails?.id,
                stripePaymentMethodType: "terminal",
                comment: donationNote,
              },
            },
          })
          if (paymentData?.startOrderPayment?.order?.stripePaymentIntentId) {
            setPaymentIntentId(
              paymentData?.startOrderPayment?.order?.stripePaymentIntentId
            )
            setPaymentStatus(paymentData?.startOrderPayment?.order?.status)
            getOrderStatus({
              variables: {
                paymentIntentId:
                  paymentData?.startOrderPayment?.order?.stripePaymentIntentId,
              },
            })
          } else {
            setPaymentStatus("ERROR")
            setLoadingAll(false)
            throw new Error("Payment failed")
          }
        }
      }
    } catch (error) {
      console.error("Payment error:", error)
      errorToast(
        formatMessage({
          id: "dashboard::stores::errorMessage",
          defaultMessage: "An error occurred",
        })
      )
      setPaymentStatus("ERROR")
      setLoadingAll(false)
    }
  }

  const handleSearch = (e) => {
    setSearchText(e.target.value)
  }
  const handleNewPurchaseClick = (e) => {
    setDonationSuccessOpen(false)
    setPaymentStatus()
    setEmail("")
    refetchOfferListing()
  }

  //Initialize the intersection observer API
  useEffect(() => {
    if (!loadRef?.current) {
      return
    }
    let options = {
      threshold: 0.5,
    }
    const observer = new IntersectionObserver(handleObserver, options)
    if (loadRef.current) {
      observer.observe(loadRef.current)
    }
    return () => {
      if (loadRef.current) {
        observer.unobserve(loadRef.current)
      }
    }
  }, [loadRef?.current, data?.allOffers?.pageInfo])

  // Handle intersection with load more
  const handleObserver = (entities) => {
    const target = entities[0]
    if (
      target.isIntersecting &&
      !loading &&
      data?.allOffers?.pageInfo?.hasNextPage
    ) {
      setLoadMoreAfter(true)
    }
  }

  // Handle loading more
  useEffect(() => {
    if (loadMoreAfter && data?.allOffers?.pageInfo?.hasNextPage && !loading) {
      handleLoadMore()
      setLoadMoreAfter(false)
    }
  }, [loadMoreAfter, data?.allOffers?.pageInfo?.hasNextPage, loading])

  const campaignImages = selectedOffer?.image
    ? [
        {
          id: 0,
          image: selectedOffer.image,
        },
      ]
    : []

  const sliderWidth = screenSize3
    ? 455
    : screenSize4
    ? 510
    : screenSize5
    ? 760
    : screenSize6
    ? 1266
    : "100%"

  const sliderHeight = screenSize3
    ? (455 * 9) / 16
    : screenSize4
    ? (510 * 9) / 16
    : screenSize5
    ? (760 * 9) / 16
    : screenSize6
    ? (1266 * 9) / 16
    : "100%"

  return (
    <>
      <StyledTerminalWrapper id="terminal" ref={ref}>
        <StyledCampaignsBody className="detail-wrapper">
          {!!selectedOffer && isTablet ? (
            <StyledCampaignDetail
              isOpen={!!selectedOffer}
              sliderWidth={`${sliderWidth}px`}
              sliderHeight={`${sliderHeight}px`}
              minHeight={`${sliderHeight + 310}px`}>
              <div
                className="close-icon"
                onClick={() => {
                  setSearchText(null)
                  setSelectedOffer()
                  setSelectedServiceOption()
                  navigateWithParams({
                    ...params,
                    offer: undefined,
                  })
                }}>
                <FontAwesomeIcon icon={faXmark} />
              </div>

              <MediaSlider
                images={campaignImages}
                altName={`detail-${selectedOffer?.name}`}
                video={selectedOffer?.video}
                imageWidth={`${sliderWidth}px`}
                imageHeight={`${sliderHeight}px`}
                videoWidth={`${sliderWidth}px`}
                videoHeight={`${sliderHeight}px`}
                className="slider"
                useCustomVideoPlayer={!!selectedOffer?.video}
              />
              <div className="content">
                <div className="logo">
                  <img
                    src={selectedOffer?.store?.logo}
                    alt={selectedOffer?.store?.name}
                  />
                </div>
                <div className="detail">
                  <div className="title">{selectedOffer?.name}</div>
                  <div
                    className="description"
                    dangerouslySetInnerHTML={{
                      __html: getValueForLocale(
                        selectedOffer,
                        "description",
                        locale,
                        defaultLocale
                      ),
                    }}
                  />
                </div>
              </div>
              <div className="footer">
                <div className="payment-methods">
                  <svg width="30" height="25" viewBox="0 -140 780 780">
                    <path
                      d="m293.2 348.73 33.359-195.76h53.358l-33.384 195.76H293.2zm246.11-191.54c-10.569-3.966-27.135-8.222-47.821-8.222-52.726 0-89.863 26.551-90.181 64.604-.297 28.129 26.515 43.822 46.754 53.185 20.771 9.598 27.752 15.716 27.652 24.283-.133 13.123-16.586 19.115-31.924 19.115-21.355 0-32.701-2.967-50.225-10.273l-6.878-3.111-7.487 43.822c12.463 5.467 35.508 10.199 59.438 10.445 56.09 0 92.502-26.248 92.916-66.885.199-22.27-14.016-39.215-44.801-53.188-18.65-9.056-30.072-15.099-29.951-24.269 0-8.137 9.668-16.838 30.56-16.838 17.446-.271 30.088 3.534 39.936 7.5l4.781 2.259 7.231-42.427m137.31-4.223h-41.23c-12.772 0-22.332 3.486-27.94 16.234l-79.245 179.4h56.031s9.159-24.121 11.231-29.418c6.123 0 60.555.084 68.336.084 1.596 6.854 6.492 29.334 6.492 29.334h49.512l-43.187-195.64zm-65.417 126.41c4.414-11.279 21.26-54.724 21.26-54.724-.314.521 4.381-11.334 7.074-18.684l3.606 16.878s10.217 46.729 12.353 56.527h-44.293v.003zm-363.3-126.41-52.239 133.5-5.565-27.129c-9.726-31.274-40.025-65.157-73.898-82.12l47.767 171.2 56.455-.063 84.004-195.39-56.524-.001"
                      fill="#0E4595"
                    />
                    <path
                      d="M146.92 152.96H60.879l-.682 4.073c66.939 16.204 111.23 55.363 129.62 102.42l-18.709-89.96c-3.229-12.396-12.597-16.096-24.186-16.528"
                      fill="#F2AE14"
                    />
                  </svg>
                  <svg width="30" height="25" viewBox="0 -54.25 482.51 482.51">
                    <path d="M87.39 373.17v-24.85c0-9.53-5.8-15.74-15.32-15.74-5 0-10.35 1.66-14.08 7-2.9-4.56-7-7-13.25-7a14.07 14.07 0 0 0-12 5.8v-5h-7.87v39.76h7.87v-22.75c0-7 4.14-10.35 9.94-10.35s9.11 3.73 9.11 10.35v22.78h7.87v-22.78c0-7 4.14-10.35 9.94-10.35s9.11 3.73 9.11 10.35v22.78Zm129.22-39.35h-14.5v-12h-7.85v12h-8.28v7h8.28v18.68c0 9.11 3.31 14.5 13.25 14.5a23.17 23.17 0 0 0 10.75-2.9l-2.49-7a13.63 13.63 0 0 1-7.46 2.07c-4.14 0-6.21-2.49-6.21-6.63V340.5h14.5v-6.63Zm73.72-1.24a12.39 12.39 0 0 0-10.77 5.8v-5h-7.87v39.76h7.87v-22.33c0-6.63 3.31-10.77 8.7-10.77a24.24 24.24 0 0 1 5.38.83l2.49-7.46a28 28 0 0 0-5.8-.83Zm-111.41 4.14c-4.14-2.9-9.94-4.14-16.15-4.14-9.94 0-16.15 4.56-16.15 12.43 0 6.63 4.56 10.35 13.25 11.6l4.14.41c4.56.83 7.46 2.49 7.46 4.56 0 2.9-3.31 5-9.53 5a21.84 21.84 0 0 1-13.25-4.14l-4.14 6.21c5.8 4.14 12.84 5 17 5 11.6 0 17.81-5.38 17.81-12.84 0-7-5-10.35-13.67-11.6l-4.14-.41c-3.73-.41-7-1.66-7-4.14 0-2.9 3.31-5 7.87-5 5 0 9.94 2.07 12.43 3.31Zm120.11 16.57c0 12 7.87 20.71 20.71 20.71 5.8 0 9.94-1.24 14.08-4.56l-4.14-6.21a16.74 16.74 0 0 1-10.35 3.73c-7 0-12.43-5.38-12.43-13.25s5.36-13.21 12.43-13.21a16.74 16.74 0 0 1 10.35 3.73l4.14-6.21c-4.14-3.31-8.28-4.56-14.08-4.56-12.43-.83-20.71 7.87-20.71 19.88Zm-55.5-20.71c-11.6 0-19.47 8.28-19.47 20.71S232.34 374 244.35 374a25.33 25.33 0 0 0 16.15-5.38l-4.14-5.8a19.79 19.79 0 0 1-11.6 4.14c-5.38 0-11.18-3.31-12-10.35h29.41v-3.31c0-12.43-7.46-20.71-18.64-20.71Zm-.41 7.46c5.8 0 9.94 3.73 10.35 9.94h-21.53c1.24-5.8 5-9.94 11.18-9.94Zm-107.27 13.25v-19.88h-7.87v5c-2.9-3.73-7-5.8-12.84-5.8-11.18 0-19.47 8.7-19.47 20.71s8.28 20.71 19.47 20.71c5.8 0 9.94-2.07 12.84-5.8v5h7.87v-19.94Zm-31.89 0c0-7.46 4.56-13.25 12.43-13.25 7.46 0 12 5.8 12 13.25 0 7.87-5 13.25-12 13.25-7.87.41-12.43-5.8-12.43-13.25Zm306.08-20.71a12.39 12.39 0 0 0-10.77 5.8v-5h-7.87v39.76h7.86v-22.33c0-6.63 3.31-10.77 8.7-10.77a24.24 24.24 0 0 1 5.38.83l2.49-7.46a28 28 0 0 0-5.8-.83Zm-30.65 20.71v-19.88h-7.87v5c-2.9-3.73-7-5.8-12.84-5.8-11.18 0-19.47 8.7-19.47 20.71s8.28 20.71 19.47 20.71c5.8 0 9.94-2.07 12.84-5.8v5h7.87v-19.94Zm-31.89 0c0-7.46 4.56-13.25 12.43-13.25 7.46 0 12 5.8 12 13.25 0 7.87-5 13.25-12 13.25-7.87.41-12.43-5.8-12.43-13.25Zm111.83 0v-35.62h-7.87v20.71c-2.9-3.73-7-5.8-12.84-5.8-11.18 0-19.47 8.7-19.47 20.71S427.43 374 438.62 374c5.8 0 9.94-2.07 12.84-5.8v5h7.87v-19.91Zm-31.89 0c0-7.46 4.56-13.25 12.43-13.25 7.46 0 12 5.8 12 13.25 0 7.87-5 13.25-12 13.25-7.88.42-12.44-5.79-12.44-13.25Z" />
                    <path
                      fill="#ff5f00"
                      d="M169.81 31.89h143.72v234.42H169.81z"
                    />
                    <path
                      d="M184.31 149.1a149.5 149.5 0 0 1 56.74-117.21 149.1 149.1 0 1 0 0 234.42 149.5 149.5 0 0 1-56.74-117.21Z"
                      fill="#eb001b"
                    />
                    <path
                      d="M482.52 149.1a148.95 148.95 0 0 1-241 117.21 149.43 149.43 0 0 0 0-234.42 148.95 148.95 0 0 1 241 117.21Z"
                      fill="#f79e1b"
                    />
                  </svg>
                  <svg width="30" height="25" viewBox="0 -149 512 512">
                    <path
                      d="M35.982 83.484c0-5.546 4.551-7.68 12.09-7.68 10.808 0 24.461 3.272 35.27 9.103V51.484c-11.804-4.693-23.466-6.542-35.27-6.542C19.2 44.942 0 60.018 0 85.192c0 39.252 54.044 32.995 54.044 49.92 0 6.541-5.688 8.675-13.653 8.675-11.804 0-26.88-4.836-38.827-11.378v33.849c13.227 5.689 26.596 8.106 38.827 8.106 29.582 0 49.92-14.648 49.92-40.106-.142-42.382-54.329-34.845-54.329-50.774Zm96.142-66.986-34.702 7.395-.142 113.92c0 21.05 15.787 36.551 36.836 36.551 11.662 0 20.195-2.133 24.888-4.693V140.8c-4.55 1.849-27.022 8.391-27.022-12.658V77.653h27.022V47.36h-27.022l.142-30.862Zm71.112 41.386L200.96 47.36h-30.72v124.444h35.556V87.467c8.39-10.951 22.613-8.96 27.022-7.396V47.36c-4.551-1.707-21.191-4.836-29.582 10.524Zm38.257-10.524h35.698v124.444h-35.698V47.36Zm0-10.809 35.698-7.68V0l-35.698 7.538V36.55Zm109.938 8.391c-13.938 0-22.898 6.542-27.875 11.094l-1.85-8.818h-31.288v165.83l35.555-7.537.143-40.249c5.12 3.698 12.657 8.96 25.173 8.96 25.458 0 48.64-20.48 48.64-65.564-.142-41.245-23.609-63.716-48.498-63.716Zm-8.533 97.991c-8.391 0-13.37-2.986-16.782-6.684l-.143-52.765c3.698-4.124 8.818-6.968 16.925-6.968 12.942 0 21.902 14.506 21.902 33.137 0 19.058-8.818 33.28-21.902 33.28ZM512 110.08c0-36.409-17.636-65.138-51.342-65.138-33.85 0-54.33 28.73-54.33 64.854 0 42.808 24.179 64.426 58.88 64.426 16.925 0 29.725-3.84 39.396-9.244v-28.445c-9.67 4.836-20.764 7.823-34.844 7.823-13.796 0-26.027-4.836-27.591-21.618h69.547c0-1.85.284-9.245.284-12.658Zm-70.258-13.511c0-16.071 9.814-22.756 18.774-22.756 8.675 0 17.92 6.685 17.92 22.756h-36.694Z"
                      fill="#6772E5"
                    />
                  </svg>
                </div>
                <div className="service-provider">
                  <span>
                    <FormattedMessage
                      id="terminal::reader::serviceProvidedBy"
                      defaultMessage="Service provided by TrustMeUp"
                    />
                  </span>
                  <LogoText
                    className="logo"
                    width="100"
                    height="30"
                    flat={false}
                    fill={theme?.colors?.blue}
                  />
                </div>
              </div>
            </StyledCampaignDetail>
          ) : (
            !isPairingOpen && (
              <>
                <StyledHeading>
                  <StyledHeadingTop>
                    {readerDetails?.label ? (
                      <div className="terminal__reader__connected">
                        {readerDetails?.label}{" "}
                        <span
                          className={
                            readerDetails?.status === "online"
                              ? "connected"
                              : "error"
                          }>
                          {readerDetails?.status === "online" ? (
                            <FormattedMessage
                              id="terminal::reader::connected"
                              defaultMessage="Connected"
                            />
                          ) : readerDetails?.status === "offline" ? (
                            <FormattedMessage
                              id="terminal::reader::offline"
                              defaultMessage="Offline"
                            />
                          ) : (
                            <FormattedMessage
                              id="terminal::reader::notConnected"
                              defaultMessage="Not Connected"
                            />
                          )}
                        </span>
                      </div>
                    ) : (
                      <FormattedMessage
                        id="terminal::reader::noPairedReader"
                        defaultMessage="No paired reader"
                        tagName={"h6"}
                      />
                    )}

                    <div
                      className="terminal__reader__pair"
                      onClick={() => {
                        setPairingOpen(true)
                        setTerminalPaired(false)
                      }}>
                      <FormattedMessage
                        id="terminal::reader::pairNew"
                        defaultMessage="Pair a new reader"
                      />
                    </div>
                  </StyledHeadingTop>
                  <StyledFilterBar>
                    <FilterBar
                      handleSearch={handleSearch}
                      allCampaignCategories={allOfferCategories}
                      ref={filterBarRef}
                      selectedCategories={selectedCategories}
                      setSelectedCategories={setSelectedCategories}
                      searchFieldName="allOffers"
                      placeholder={formatMessage({
                        id: "terminal::reader::searchServices",
                        defaultMessage: "Search for services",
                      })}
                    />
                  </StyledFilterBar>
                </StyledHeading>
                <StyledContent>
                  {loading ? (
                    <Spinner />
                  ) : (
                    <StyledCampaignList>
                      {loading ? (
                        <Spinner />
                      ) : (
                        <>
                          {offerList.length ? (
                            <>
                              {offerList.map(({ node: offer }) => {
                                return (
                                  <NewCard
                                    variant={
                                      offer?.isDefaultOffer ? "store" : "offer"
                                    }
                                    id={offer?.id}
                                    key={offer?.id}
                                    imageSrc={offer?.image}
                                    title={getValueForLocale(
                                      offer,
                                      "name",
                                      locale,
                                      defaultLocale
                                    )}
                                    description={getValueForLocale(
                                      offer,
                                      "description",
                                      locale,
                                      defaultLocale
                                    )}
                                    maxPacDiscount={offer?.maxPacDiscount}
                                    size={
                                      !isTablet
                                        ? LIST_TYPES.LIST
                                        : LIST_TYPES.TILE
                                    }
                                    storeLogo={getValueForLocale(
                                      offer?.store,
                                      "logo",
                                      locale,
                                      defaultLocale
                                    )}
                                    storeName={
                                      offer?.store?.displayName ||
                                      offer?.store?.name
                                    }
                                    isComingSoon={
                                      offer?.store?.badge === "COMING_SOON"
                                    }
                                    onClick={() => {
                                      setPaymentStatus()
                                      if (isTablet) {
                                        setSelectedOffer(offer)
                                        navigateWithParams({
                                          ...params,
                                          offer: offer.slug,
                                        })
                                      } else {
                                        setPairingOpen(true)
                                        navigateWithParams({
                                          ...params,
                                          offer: offer.slug,
                                        })
                                      }
                                    }}
                                  />
                                )
                              })}
                            </>
                          ) : (
                            <NoResults>
                              <FormattedMessage
                                id="campaignListing::filters::noResult"
                                defaultMessage="We couldn't find any results ("
                                tagName="h6"
                              />
                            </NoResults>
                          )}
                        </>
                      )}
                    </StyledCampaignList>
                  )}

                  <CampaignListAction ref={loadRef}>
                    {data?.allOffers?.pageInfo?.hasNextPage && (
                      <Spinner condensed />
                    )}
                  </CampaignListAction>
                </StyledContent>
                <StyledListingFilters></StyledListingFilters>
              </>
            )
          )}
        </StyledCampaignsBody>

        {isTerminalPaired ? (
          <StyledDonationSectionTerminalPaired isTerminalPaired>
            <StyledDonationSectionTerminalPairedTop>
              <div>
                <p>{readerDetails?.label}</p>
                <span
                  className={
                    readerDetails?.status === "online" ? "connected" : "error"
                  }>
                  {readerDetails?.status === "online" ? (
                    <FormattedMessage
                      id="terminal::reader::connected"
                      defaultMessage="Connected"
                    />
                  ) : connecting ? (
                    <FormattedMessage
                      id="terminal::reader::connecting"
                      defaultMessage="Connecting..."
                    />
                  ) : readerDetails?.label ? (
                    <FormattedMessage
                      id="terminal::reader::connectionError"
                      defaultMessage="Connection Error"
                    />
                  ) : (
                    <FormattedMessage
                      id="terminal::reader::notConnected"
                      defaultMessage="Not Connected"
                    />
                  )}
                </span>
              </div>
              <Button
                variant="text"
                onClick={() => {
                  setPairingOpen(false)
                  setTerminalPaired(false)
                  setSelectedServiceOption()
                  setEmail("")
                }}>
                <FormattedMessage
                  id="terminal::reader::pairNew"
                  defaultMessage="Pair a new reader"
                />
              </Button>
            </StyledDonationSectionTerminalPairedTop>
            <StyledDonationSectionTerminalPairedOptions>
              {isDonationSuccessOpen &&
              (selectedServiceOption?.donationAmount ||
                selectedDonationAmount) &&
              selectedOffer?.name ? (
                <StyledDonationSuccessSection>
                  <div>
                    <FormattedMessage
                      id="campaign::purchaseSuccess::processedText1"
                      defaultMessage="Service is purchased!"
                      tagName={"h3"}
                    />
                  </div>
                  <StyledSuccessPageImage>
                    <LazyImage
                      altName="donation-success"
                      src={
                        CLOUDFLARE_IMAGE_URL +
                        "/static/assets/images/tmu_celebration.gif"
                      }
                      width="300"
                      fit="cover"
                    />
                    <div className="caption" style={{ textAlign: "center" }}>
                      <FormattedMessage
                        id="campaign::donationSuccess::purchased"
                        defaultMessage="You purchased"
                      />
                    </div>

                    <p>
                      {selectedOffer?.store?.name}
                      <br />
                      {selectedOffer?.name}
                    </p>
                    <FormattedMessage
                      id="campaign::donationSuccess::email"
                      defaultMessage="We have sent you a confirmation email."
                      tagName="p"
                    />
                    <Button
                      color="blue"
                      type="submit"
                      onClick={handleNewPurchaseClick}>
                      <FormattedMessage
                        id="terminal::reader::newPurchase"
                        defaultMessage="New Purchase"
                        tagName="span"
                      />{" "}
                      {countdown !== null && countdown > 0 && ` (${countdown})`}{" "}
                    </Button>
                  </StyledSuccessPageImage>
                </StyledDonationSuccessSection>
              ) : !selectedOffer ? (
                <>
                  <StyledDonationSection>
                    <FormattedMessage
                      id="terminal::reader::serviceOptions"
                      defaultMessage="Service options"
                      tagName="h3"
                    />
                    <FormattedMessage
                      id="terminal::reader::serviceOptionsDesc"
                      defaultMessage="Choose a service to purchase from the catalog to see service options here"
                      tagName="h5"
                    />
                  </StyledDonationSection>
                </>
              ) : (
                <StyledDonationOptionSection>
                  <div>
                    <p className="caption">
                      <FormattedMessage
                        id="terminal::reader::serviceOptions"
                        defaultMessage="Service options"
                      />
                    </p>

                    <StyledDonationOptions className="options">
                      <div className="donation-options">
                        {serviceOptions
                          ?.filter((option) => !option.allowCustomAmount)
                          ?.map((option) => (
                            <label
                              className={`option ${
                                selectedServiceOption?.id === option.id
                                  ? "selected"
                                  : ""
                              }`}>
                              <input
                                type="radio"
                                name="donation"
                                onChange={() =>
                                  setSelectedServiceOption(option)
                                }
                              />
                              <div className="option-content">
                                <span className="price">
                                  € {option.donationAmount}
                                </span>
                                <span className="description">
                                  {option.description}
                                </span>
                              </div>
                            </label>
                          ))}
                        {serviceOptions
                          ?.filter((option) => option.allowCustomAmount)
                          ?.map((option) => (
                            <label className="option input">
                              <input
                                type="radio"
                                name="donation"
                                onChange={(e) =>
                                  setSelectedServiceOption(option)
                                }
                              />
                              <div className="option-content">
                                <span className="description">
                                  <TextInput
                                    newDesign
                                    id="amount"
                                    name="amount"
                                    type="number"
                                    label={""}
                                    autoComplete="off"
                                    disabled={
                                      selectedServiceOption?.id !== option.id
                                    }
                                    className="float-container"
                                    placeholder={formatMessage({
                                      id: "terminal::reader::otherAmount",
                                      defaultMessage: "Other amount",
                                    })}
                                    value={
                                      selectedServiceOption?.id === option.id
                                        ? selectedServiceOption?.donationAmount
                                        : ""
                                    }
                                    touched={true}
                                    onChange={(e) =>
                                      handleAmountChange(e, option)
                                    }
                                    error={
                                      selectedServiceOption?.id === option.id &&
                                      (amountError ||
                                        (!selectedServiceOption?.donationAmount &&
                                          formatMessage({
                                            id: "forms::enterAmount",
                                            defaultMessage: "Enter an amount",
                                          })))
                                    }
                                  />
                                </span>
                              </div>
                            </label>
                          ))}
                      </div>
                    </StyledDonationOptions>

                    {selectedOffer?.enableDonationNote && (
                      <div>
                        <p className="caption">
                          <FormattedMessage
                            id="campaign::donationForm::NGOMessage"
                            defaultMessage="Message"
                          />
                        </p>
                        <TextInput
                          newDesign
                          className="note"
                          id="note"
                          name="note"
                          value={donationNote}
                          maxLength={120}
                          placeholder={formatMessage({
                            id: "campaign::donationForm::NGOMessagePlaceHolder",
                            defaultMessage: "Leave your comment here",
                          })}
                          onChange={(e) => setDonationNote(e.target.value)}
                        />
                      </div>
                    )}
                  </div>
                  <div>
                    {showEmail ? (
                      <TextInput
                        newDesign
                        id="email"
                        name="email"
                        type="email"
                        label={formatMessage({
                          id: "signUp::email",
                          defaultMessage: "Email",
                        })}
                        className="float-container"
                        placeholder={formatMessage({
                          id: "forms::emailRequiredError",
                          defaultMessage: "Enter your email",
                        })}
                        value={email}
                        touched={true}
                        onChange={handleEmailChange}
                        error={emailError}
                      />
                    ) : null}
                    <Button
                      color="blue"
                      type="submit"
                      onClick={handleDonate}
                      disabled={
                        loadingAll ||
                        createNewOrderLoading ||
                        readerDetails?.status !== "online" ||
                        (!selectedServiceOption?.donationAmount &&
                          !selectedDonationAmount) ||
                        (showEmail && !email) ||
                        emailError ||
                        amountError ||
                        !readerDetails?.id ||
                        !selectedOffer?.id
                      }>
                      {loadingAll ||
                      paymentStatus === "requires_payment_method" ? (
                        <div className="loading-animation">
                          <Loading condensed />
                        </div>
                      ) : (
                        <>
                          <FormattedMessage
                            id="terminal::reader::purchase"
                            defaultMessage="Purchase"
                            tagName="span"
                          />
                        </>
                      )}
                    </Button>
                    {process.env.GATSBY_ACTIVE_ENV !== "production" &&
                    paymentStatus === "requires_payment_method" ? (
                      <p className="simulate" onClick={handleSimulate}>
                        Simulate Payment
                      </p>
                    ) : null}
                    {paymentStatus === "requires_payment_method" ? (
                      <p className="cancel" onClick={handleCancelDonation}>
                        <FormattedMessage
                          id="dashboard::forms::cancel"
                          defaultMessage="Cancel"
                        />
                      </p>
                    ) : null}
                  </div>
                </StyledDonationOptionSection>
              )}
            </StyledDonationSectionTerminalPairedOptions>
          </StyledDonationSectionTerminalPaired>
        ) : null}

        {isPairingOpen ? (
          <StyledDonationSectionPair isPairingOpen>
            <div className="top">
              <FontAwesomeIcon
                icon={faArrowLeft}
                onClick={() => setPairingOpen(false)}
              />
              <FormattedMessage
                id="terminal::reader::pairReader"
                defaultMessage="Pair Reader"
                tagName="h2"
              />
            </div>
            <TextInput
              newDesign
              data-testid="input-words"
              id="words"
              name="words"
              className="float-container"
              label={formatMessage({
                id: "terminal::reader::type3words",
                defaultMessage: "Type 3 words code for pairing",
              })}
              value={threeWords}
              onChange={(e) => {
                setThreeWords(e.target.value)
              }}
            />
            <TextInput
              newDesign
              data-testid="input-reader"
              id="reader"
              name="reader"
              className="float-container"
              label={formatMessage({
                id: "terminal::reader::readerName",
                defaultMessage: "Reader name",
              })}
              value={readerName}
              onChange={(e) => {
                setReaderName(e.target.value)
              }}
            />
            <Button
              color="blue"
              disabled={!threeWords || !readerName}
              onClick={handleStartPairing}>
              <FormattedMessage
                id="terminal::reader::startPairing"
                defaultMessage="Start pairing"
              />
            </Button>
            {process.env.GATSBY_ACTIVE_ENV !== "production" ? (
              <p
                className="simulate"
                onClick={() => {
                  setReaderDetails(simulator)
                  setTerminalPaired(true)
                  setPairingOpen(false)
                }}>
                Use Simulator
              </p>
            ) : null}
          </StyledDonationSectionPair>
        ) : !isTerminalPaired && isTablet ? (
          <StyledDonationSection>
            <FormattedMessage
              id="terminal::reader::connectReader"
              defaultMessage="Connect to Reader"
              tagName="h3"
            />
            <FormattedMessage
              id="terminal::reader::notPairedYet"
              defaultMessage="You have not paired any Reader yet"
              tagName="h5"
            />
            <div className="wrapper">
              <TextInput
                newDesign
                data-testid="input-reader"
                id="reader"
                name="reader"
                className="float-container"
                placeholder={formatMessage({
                  id: "terminal::reader::readerId",
                  defaultMessage: "Enter your reader id",
                })}
                value={inputReaderId}
                onChange={(e) => {
                  setInputReaderId(e.target.value)
                }}
              />
              <span
                className="pair"
                onClick={() => {
                  if (inputReaderId) {
                    setReaderDetails({
                      id: inputReaderId,
                      status: "offline",
                    })
                    setConnecting(true)
                    setTerminalPaired(true)
                    setPairingOpen(false)
                  }
                }}>
                <FormattedMessage
                  id="terminal::reader::pair"
                  defaultMessage="Pair"
                />
              </span>
              <div className="terminal__reader__or">
                <FormattedMessage
                  id="terminal::reader::or"
                  defaultMessage="or"
                />
              </div>
            </div>
            <Button
              variant="text"
              onClick={() => {
                setPairingOpen(true)
              }}>
              <FormattedMessage
                id="terminal::reader::pairNew"
                defaultMessage="Pair a new reader"
              />
            </Button>
          </StyledDonationSection>
        ) : null}
      </StyledTerminalWrapper>
      {modalStatus && (
        <CustomModal
          isModalOpen={modalStatus}
          style={style}
          header={headerText}
          text={descriptionText}
          children={content}
          isCloseIcon={false}
          cancelButtonAction={closeModal}
          isMobile={true}
          isFull={true}
        />
      )}
    </>
  )
}

export default Terminal

const style = { padding: "0 1rem 1rem" }
const headerText = "header text"
const descriptionText = "description text"
const content = "content"
const closeModal = () => {}
const fullContent = "full content"
